export var APP_INIT = 'APP_INIT';
export var onInit = function onInit() {
  return {
    type: APP_INIT
  };
};